import React, { useState, useEffect } from "react";
import { Stack, IconButton, Button, TextField, Grid } from "@mui/material";
import { InputPoll } from "~components/atoms";
import { SubTitle } from "~components/atoms";
import { CloseIcon } from "~components/Icons";
import { usePollContext } from "~contexts/Poll";
import { validateImage, validateQuestion, validateOptions } from "./validations";
import {
  CREATION_INITIAL_STATE,
  INPUTS_INITIAL_STATE,
  QUESTION_MAX_LENGTH,
} from "./constants";
import type { IStatus } from "./interfaces";
import type { IPollCreation } from "~contexts/Socket/interfaces";

const PollCreation: React.FC = () => {
  const { onCreatePoll, isEditing, setIsEditing, onRefreshPolls } = usePollContext();
  const [inputStatus, setInputStatus] = useState<IStatus[]>(INPUTS_INITIAL_STATE);
  const [pollCreation, setPollCreation] = useState<IPollCreation>(CREATION_INITIAL_STATE);

  const onSubmit = () => {
    const { question, option1, option2, image1, image2 } = pollCreation;
    const isAnImage = /(https?:\/\/.*\.(?:png|jpg))/i;
    const isImage1Valid = !!image1.match(isAnImage);
    const isImage2Valid = !!image2.match(isAnImage);

    if ((image1.length > 0 && !isImage1Valid) || (image2.length > 0 && !isImage2Valid)) {
      return;
    }

    if (!question) {
      validateQuestion(setInputStatus, inputStatus);
      return;
    }

    if (isImage2Valid && !isImage1Valid) {
      validateImage(1, setInputStatus, inputStatus);
      return;
    }

    if (isImage1Valid && !isImage2Valid) {
      validateImage(2, setInputStatus, inputStatus);
      return;
    }

    if (!option1 || !option2) {
      validateOptions(inputStatus, setInputStatus, pollCreation);
      return;
    }

    onCreatePoll(pollCreation);
    onRefreshPolls();
  };

  useEffect(() => {
    if (!isEditing) {
      setPollCreation(CREATION_INITIAL_STATE);
      setInputStatus(INPUTS_INITIAL_STATE);
    }
  }, [isEditing]);

  return (
    <Stack>
      <Grid
        container
        justifyContent="space-between"
        flexDirection="row"
        alignItems="center"
      >
        <SubTitle title="enquete 1" description="" />
        <IconButton onClick={() => setIsEditing(false)} sx={{ mt: "65px" }}>
          <CloseIcon />
        </IconButton>
      </Grid>

      <TextField
        fullWidth
        hiddenLabel
        variant="outlined"
        value={pollCreation.question}
        placeholder="texto da pergunta"
        inputProps={{ maxLength: QUESTION_MAX_LENGTH }}
        error={inputStatus.find((input) => input.type === "question")?.isInvalid}
        onChange={(e) => setPollCreation({ ...pollCreation, question: e.target.value })}
        sx={{
          mt: "12px",
          "& input::placeholder": {
            fontSize: "16px",
            opacity: 1,
          },
        }}
      />

      {inputStatus
        .filter(({ type }) => type !== "question")
        .map(({ name, id, isInvalid, isImageInvalid }) => (
          <InputPoll
            key={name}
            index={id}
            pollOnCreation={pollCreation}
            setPollOnCreation={setPollCreation}
            isTextInvalid={isInvalid}
            isImageInvalid={isImageInvalid}
          />
        ))}

      <Stack sx={{ display: "flex", flexDirection: "row" }}>
        <Button
          sx={{ width: "164px", height: "56px", mt: "12px" }}
          variant="secondaryButton"
          onClick={() => onSubmit()}
        >
          cadastrar enquete
        </Button>
        <Button
          onSubmit={() => alert("opa")}
          sx={{ mt: "13px", ml: "20px" }}
          variant="text"
          onClick={() => setIsEditing(false)}
        >
          cancelar enquete
        </Button>
      </Stack>
    </Stack>
  );
};

export default PollCreation;
